import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { ReturnAddressService } from 'common/data';

class ReturnAddressStore extends BaseStore {
	constructor(rootStore) {
		super(new ReturnAddressService(rootStore.app.baasic.apiClient));
	}

	@action async findReturnAddress(filter) {
		const response = await this.service.find(filter);
		return (this.response = response.data);
	}

	@action async deleteReturnAddress(id) {
		await this.service.remove(id);
	}

	@action async updateReturnAddress(returnAddress, sourceOfChange) {
		await this.service.update(returnAddress, sourceOfChange);
	}

	@action
	createReturnAddress = async (returnAddress, sourceOfChange) => {
		await this.service.create(returnAddress, sourceOfChange);
	};
}

export default ReturnAddressStore;



// WEBPACK FOOTER //
// ./src/modules/return-address/stores/ReturnAddressStore.js